import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { LoginSelectors } from '../../redux/LoginRedux';
import LoginCreators from '../../redux/LoginRedux';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import './NotFoundPage.css';

interface NotFoundPageState {
  loading: boolean;
  isOnline: boolean;
  isStandalone: boolean;
}

interface NotFoundPageProps {
  accessToken: string | null;
  isFetching: boolean;
  isSuccess: boolean;
  hasError: boolean;
  dispatch: any;
}

class NotFoundPage extends Component<NotFoundPageProps, NotFoundPageState> {
  constructor(props: NotFoundPageProps) {
    super(props);
    this.state = {
      loading: false,
      isOnline: navigator.onLine,
      isStandalone: window.matchMedia && window.matchMedia('(display-mode: standalone)').matches
    };
  }

  componentDidMount() {
    // Initialize page data
    console.log('NotFoundPage mounted');
    console.log('Redux State:', {
      accessToken: this.props.accessToken,
      isFetching: this.props.isFetching,
      isSuccess: this.props.isSuccess,
      hasError: this.props.hasError
    });

    // Listen for online/offline events
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
  }

  handleOnline = () => {
    this.setState({ isOnline: true });
  };

  handleOffline = () => {
    this.setState({ isOnline: false });
  };

  handleTestLogin = () => {
    // Test login with mock data
    this.props.dispatch(LoginCreators.loginRequest(
      'test@example.com',
      'password123',
      'mock_notification_token',
      'en'
    ));
  };

  render() {
    const { loading, isOnline, isStandalone } = this.state;
    const { accessToken, isFetching, isSuccess, hasError } = this.props;
    const isAuthenticated = !!accessToken;

    return (
      <div className="not-found-page">
        <div className="error-container">
          <h1>404</h1>
          <p>Oops! The page you’re looking for doesn’t exist.</p>
          <Link to="/" className="btn">Go Home</Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  accessToken: state.login.accessToken,
  isFetching: state.login.fetching,
  isSuccess: state.login.success,
  hasError: state.login.error,
});

export default connect(mapStateToProps)(NotFoundPage);
